import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=49c1a358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c1a358"]])

export default __exports__